
import { defineComponent, ref, watch } from 'vue'
import { RouteRecordName, useRoute } from 'vue-router'
export default defineComponent({
    setup() {
        const routeName = ref<RouteRecordName|null|undefined>('')
        const isPost = ref<Boolean>(false)
        const route = useRoute()
        watch(() => route.name, () => {
            routeName.value = route.name
            isPost.value = route.name === 'Post'
        })

        return {
            routeName,
            isPost
        }
    }
})
